import AnimatedModal from "components/common/AnimatedModal";
import React, { useEffect, useMemo, useState } from "react";
import { Typography } from "@material-ui/core";
import { S } from "./styles";
import palette from "palette";
import { IGroup, IStudent } from "@rose-arch-holdings-ltd/common";
import { getMirrorList } from "lib/mirror";

interface IProps {
  isOpen: boolean;
  handleCloseModal: () => void;
  group: IGroup | undefined;
  studentNames: string[];
  removeFromGroup: () => void;
  submitted: boolean;
  error: boolean;
  schoolStudents: IStudent[];
}

export const RemoveStudentFromGroupModel: React.FC<IProps> = ({
  isOpen,
  handleCloseModal,
  error,
  removeFromGroup,
  submitted,
  studentNames,
  group,
  schoolStudents,
}) => {
  const [mirrorNames, setMirrorNames] = useState<string[]>([]);

  useEffect(() => {
    if (group?._id) {
      getMirrorList([group?._id]).then((res) => {
        const names = res.data.map((g: IGroup) => g.name);
        setMirrorNames(names);
      });
    }
  }, [group, studentNames]);

  return (
    <AnimatedModal
      open={isOpen}
      title="Remove from Group"
      handleClose={() => handleCloseModal()}
      maxWidth="625px"
      minHeight="200px"
      width="100%"
    >
      <>
        <Typography align={"center"} variant="body2">
          The following students will be removed from{" "}
          <strong>{group?.name}</strong>:
          <br />
          {studentNames
            .map((s) => {
              const student = schoolStudents.find(
                (v) => v._id.toString() === s
              );
              return student?.name;
            })
            .join(", ")}
          <br />
          <br />
          The above students will lose access to the following wheels:
          <br />
          <strong>{mirrorNames.join(", ")}</strong>
          <br />
          <br />
          <strong style={{ color: "red" }}>
            This will also DELETE ALL EVIDENCE on these wheels for these
            students.
          </strong>
          <br />
          <br />
          Consider locking these students instead if you wish to retain their
          data.
        </Typography>
        <Typography
          style={{
            color: !error ? palette.complete : palette.error,
            marginBottom: "20px",
            textAlign: "center",
          }}
          variant="body2"
        >
          {error && "Error removing group"}
          {submitted && !error && "Successfully removed"}
        </Typography>
        <S.ActionContainer>
          <S.Button
            variant="outlined"
            color="primary"
            onClick={() => handleCloseModal()}
          >
            cancel
          </S.Button>
          <S.Button
            variant="contained"
            color="secondary"
            disabled={submitted}
            onClick={() => removeFromGroup()}
          >
            remove
          </S.Button>
        </S.ActionContainer>
      </>
    </AnimatedModal>
  );
};
